import { SelectedProductActivityWebEntity } from "./selected-product-activity.web-entity"
import { ServiceHourWebEntity } from "./service-hour.web-entity"


export interface SelectedProductWebEntity {
    productId: string
    selectedProductActivities: SelectedProductActivityWebEntity[]
    serviceHours: ServiceHourWebEntity[]
}